import { createAction, props } from '@ngrx/store';
import { User } from '../../../shared/user/user.model';
import { Association } from '../../../shared/association/association.model';
import { UserAccess } from '../../../shared/user/user-access.model';
import { Access } from '../../../shared/featurePermission/access';
import { RequestTime } from '../../../shared/user/request-time.model';

export const login = createAction(
  '[Login Page] User Login',
  props<{ email: string; password: string }>(),
);

export const loginSuccess = createAction(
  '[Login Page] User Login Success',
  props<{ token: string, id: string }>(),
);
export const loginFailure = createAction( '[Login Page] User Login Failure' );

export const logout = createAction( '[Login Page] User Logout' );

export const logoutSuccess = createAction( '[Login Page] User Logout Success' );
export const logoutFailure = createAction( '[Login Page] User Logout Failure' );

export const setLoggedUser = createAction( '[Login Page] Set Logged User',
  props<{ user: User }>(),
);

export const setUserAccess = createAction( '[Login Page] Set User Access',
  props<{ access: UserAccess }>(),
);

export const loadUserAccess = createAction( '[Login Page] Load Logged User',
  props<{ userId: string }>(),
);

export const loadUserAccessSuccess = createAction( '[Login Page] Load Logged User Success',
  props<{ accesses: UserAccess[] }>(),
);

export const loadUserAccessFailure = createAction( '[Login Page] Load Logged User Failure' );

export const setCurrentAssociation = createAction( '[Login Page] Set Current Association',
  props<{ associationId: string }>(),
);

export const getUserAssociations = createAction( '[Association Access] Get Logged User Associations',
);

export const getUserAssociationsSuccess = createAction( '[Association Access] Get Logged User Associations Success',
  props<{ associations: Association[] }>(),
);

export const getUserAssociationsFailure = createAction( '[Association Access] Get Logged User Associations Failure',
);
